/**
 * Type guard to check if a value is a record (object with string keys)
 */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

/**
 * Safely extract a string value from a record by key
 * Returns null if the value is not a string or the key doesn't exist
 */
export function getRecordString(value: unknown, key: string): string | null {
  if (!isRecord(value)) return null;
  const v = value[key];
  return typeof v === "string" ? v : null;
}

